import { IconWrap, MessagesBubbleSquareTextIcon } from '@libs/ui/ds'
import { FieldDraftContent } from '@spa/components'
import classnames from 'classnames'
import React from 'react'
import type { FC } from 'react'

import styles from './DayNote.module.css'

type Props = {
  note: string
  canEditNotes: boolean
  onClick?: (e: any) => void
}
const DayNote: FC<Props> = ({ note, canEditNotes, onClick }) => {
  return (
    <button
      type='button'
      onClick={onClick}
      className={classnames(styles.Button, {
        [styles.ReadOnly]: !canEditNotes
      })}
    >
      <IconWrap
        icon={<MessagesBubbleSquareTextIcon />}
        size='s'
        className='mr-0.5 mt-0.5'
      />
      <FieldDraftContent className={styles.Content} content={note} />
    </button>
  )
}

export default DayNote
